import React, { memo } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

import { translate } from '../../helpers/stringHelpers'

// components
import Col from '../col'
import FormGroup from '../formGroup'
import FormInput from '../formInput'
import FormLabel from '../formLabel'
import Row from '../row'

const INPUT_LABELS = {
  searchInput: 'searchInput',
  countries: 'countries',
  categories: 'categories'
}

const selectStyles = {
  control: provided => ({ ...provided, minHeight: 'auto' }),
  clearIndicator: provided => ({ ...provided, padding: '0px 4px' }),
  dropdownIndicator: provided => ({ ...provided, padding: '0px 4px' }),
  menu: provided => ({ ...provided, zIndex: 9999 })
}

const ListingSearchForm = (props) => {
  const hasCountries = props.countries.length > 1
  const hasCategories = props.categories.length > 1
  const largeSearchSize = hasCountries
    ? hasCategories
      ? 3
      : 6
    : hasCategories
      ? 6
      : 9

  const handleSubmit = e => e.preventDefault()
  const handleOpenCheckboxChange = (isChecked) => props.onFilterSelection('filterOpenOnly', isChecked)

  return (
    <form onSubmit={handleSubmit} className='timed-search-form'>
      <Row>
        <Col xs={12} sm={12} lg={largeSearchSize}>
          <FormGroup>
            <FormLabel
              for={INPUT_LABELS.searchInput}
              id='searchInput__label'
            >
              {translate('JspPublicCodes_JSP_AUCTION_SEARCH_LABEL')}
            </FormLabel>
            <FormInput
              id={INPUT_LABELS.searchInput}
              dataRef={INPUT_LABELS.searchInput}
              type='search'
              onChange={props.onSearchInputChange}
              placeholder={translate('JspPublicCodes_JSP_LISTINGS_SEARCH_PLACEHOLDER')}
              value={props.searchValue}
            />
          </FormGroup>
        </Col>
        {hasCountries
          ? (
          <Col xs={hasCategories ? 6 : 12} sm={hasCategories ? 4 : 8} lg={3}>
            <FormGroup>
              <FormLabel
                for={INPUT_LABELS.countries}
                id='countries__label'
              >
                {translate('SearchFilterCodes_COUNTRY')}
              </FormLabel>
              <Select
                isMulti
                id={INPUT_LABELS.countries}
                name={INPUT_LABELS.countries}
                aria-label={translate('SearchFilterCodes_COUNTRY')}
                options={props.countries}
                placeholder={translate('JspPublicCodes_JSP_LABEL_SELECT')}
                value={props.selectedCountries}
                onChange={props.onCountrySelection}
                styles={selectStyles}
              />
            </FormGroup>
          </Col>
            )
          : null}
        {hasCategories
          ? (
          <Col xs={hasCountries ? 6 : 12} sm={hasCountries ? 4 : 8} lg={3}>
            <FormGroup>
              <FormLabel
                id='categories__label'
                for={INPUT_LABELS.categories}
              >
                {translate('SearchFilterCodes_CATEGORIES')}
              </FormLabel>
              <Select
                isMulti
                id={INPUT_LABELS.categories}
                name={INPUT_LABELS.categories}
                aria-label={translate('SearchFilterCodes_CATEGORIES')}
                options={props.categories}
                placeholder={translate('JspPublicCodes_JSP_LABEL_SELECT')}
                value={props.selectedCategories}
                onChange={props.onCategorySelection}
                styles={selectStyles}
              />
            </FormGroup>
          </Col>
            )
          : null}
        <Col xs={12} sm={4} lg={3}>
          <FormGroup>
            <Row>
              <Col xs={6} sm={12}>
                <FormLabel
                  id='filtering__label'
                />
                <FormInput
                  type='checkbox'
                  id='filterOpen'
                  isChecked={props.isOpenOnly}
                  onChange={handleOpenCheckboxChange}
                  className='timed-search-form__input--check'
                >
                  <span id='filterOpen__label'>
                    {translate('JspPublicCodes_JSP_TIMED_SHOW_OPEN_LABEL')}
                  </span>
                </FormInput>
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
    </form>
  )
}

ListingSearchForm.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  onFilterSelection: PropTypes.func.isRequired,
  onSearchInputChange: PropTypes.func.isRequired,
  isOpenOnly: PropTypes.bool.isRequired,
  onCategorySelection: PropTypes.func.isRequired,
  onCountrySelection: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  selectedCategories: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  selectedCountries: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired
}

ListingSearchForm.defaultProps = {
  categories: [],
  countries: [],
  searchValue: '',
  selectedCategories: [],
  selectedCountries: []
}

export default memo(ListingSearchForm)
